import { ErrorPage } from "@/components/ui/error-page";
import React from 'react';

const Forbidden: React.FC = () => {
  return (
    <ErrorPage
      code="403"
      title="Access Forbidden"
      subtitle="You don't have permission to access this resource"
    />
  );
};

export default Forbidden;
